/**
 * Singleton tracking the stream count. Will be used to find out if the user has
 * "aborted" the stream or not. For example, a stream can be aborted if the
 * consumer component gets unmounted before the stream of text could be resolved
 * or if it was rejected due to an error.
 */
let streamCount = 0;

export const getStreamCount = (): number => {
  return streamCount;
};

export const incrementStreamCount = (): void => {
  streamCount += 1;
};
